<template>
  <Td
    class="text-sm text-gray-800"
    :data-table-cell="field.key"
    :data-id="field.dataId ? field.dataId : 'table-cell'"
  >
    <span v-if="isRegression">{{ field.key }}</span>
    <span v-else-if="field.attachmentCount" data-id="attachment-count">
      <Icon
        class="icon"
        v-if="item && item.attachments && item.attachments.length"
        :class="muteUnlessHover"
        icon="attachments"
      />
    </span>
    <span v-else-if="field.badge" data-id="field-badge" data-badge>
      <FormBadge
        size="sm"
        :variant="
          field.badgeVariant ? field.badgeVariant(item) : Variant.secondary
        "
      >
        {{ value }}
      </FormBadge>
    </span>
    <span v-else-if="field.byteCount" data-id="byte-count">
      <ByteSize :v-if="field.key" :value="value" />
    </span>
    <span
      class="whitespace-nowrap"
      v-else-if="field.inboxEmailAddress"
      data-id="inbox-email-address"
    >
      <InboxEmailAddress :inbox="item" :v-if="field.key" :copy="false" />
    </span>
    <span v-else-if="field.uuid" data-id="uuid">
      <UUID :short="true" :v-if="field.key" :value="value" />
    </span>
    <span
      v-else-if="field.expiresAt"
      data-id="expires-at"
      :data-value="value || '0'"
      :class="muteUnlessHover"
    >
      <ExpiresAt :v-if="field.key" :value="value" />
    </span>
    <span v-else-if="field.ago" data-id="ago">
      <Ago :v-if="field.key" :value="value" />
    </span>
    <span class="text-break no-p-m" v-else data-id="text">
      {{ value }}
    </span>
  </Td>
</template>
<script setup lang="ts" generic="T extends DataTableItem">
import Icon from '~/components/form/Icon.vue';
import type { Field } from '~/lib/services/helpers';
import UUID from '~/components/form/UUID.vue';
import Ago from '~/components/form/Ago.vue';
import ExpiresAt from '~/components/form/ExpiresAt.vue';
import ByteSize from '~/components/form/ByteSize.vue';
import InboxEmailAddress from '~/components/form/InboxEmailAddress.vue';
import { useStore3 } from '~/store/main';
import FormBadge from '~/components/form/FormBadge.vue';
import { Variant } from '~/store/_types';
import Td from '~/components/table/parts/Td.vue';
import { computed } from '#imports';
import type { DataTableItem } from '~/lib/services/types';
const store3 = useStore3();
const { regressionTest } = storeToRefs(store3);
const muteUnlessHover = 'text-gray-400 group-hover/tr:text-gray-600';
const props = defineProps<{
  field: Field<T>;
  item: T;
}>();

const isRegression = computed(() => {
  return regressionTest.value;
});

const value = computed<string>(() => {
  const empty = '-';
  if (props.field.supply) {
    return props.field.supply(props.item);
  } else if (props.field.key && props.field.key in props.item) {
    return (props.item[props.field.key!] as string) || empty;
  } else {
    return empty;
  }
});
</script>
